import { useT } from "@/i18n";
import { SparkMascot } from "@/components/Mascots";
import { WEB_TEXT } from "@/components/webdev/content";
import PlatformCards from "@/components/webdev/PlatformCards";
import Glossary from "@/components/webdev/Glossary";
import ChatGptPrompts from "@/components/webdev/ChatGptPrompts";
import DomainIdea from "@/components/webdev/DomainIdea";

export default function WebWorkshop() {
  const { lang } = useT();
  return (
    <section className="learn-bg rounded-[2rem] border-4 border-white shadow-xl p-5 sm:p-8 mt-8 space-y-10" data-testid="web-workshop">
      <div className="flex items-center gap-4">
        <SparkMascot className="w-20 sm:w-28 shrink-0" />
        <h2 className="font-fredoka text-2xl sm:text-4xl font-bold bubble-text text-white">{WEB_TEXT[lang].title}</h2>
      </div>
      <Glossary />
      <PlatformCards />
      <DomainIdea />
      <ChatGptPrompts />
    </section>
  );
}
